import React, { Fragment } from 'react';
import { Dropdown } from 'react-bootstrap';
import { FaArrowRight } from 'react-icons/fa';
import { DropdownToggle, Input, InputGroup, InputGroupText } from 'reactstrap';
import { ArcaComponent } from '../../pages/ArcaComponent';
import { PetMultiSelect2 } from './PetMultiSelect2';

export class PetSelect extends ArcaComponent {

    constructor(props) {
        super(props);
        this.state = {
            pets: this.props.pets,
            status: null,
            mandatory: this.props.mandatory,
            fieldValid: null,
            dropdownOpen: false,
            label: this.props.label ?? this.props.fieldname,
            popupVisible: false,
        };
    }

    render() {
        return (
            <Fragment>
                <InputGroup>
                    {/*<InputGroupAddon addonType='prepend'>*/}
                        <InputGroupText>
                            {this.state.label}
                            {
                                this.props.mandatory
                                    ? <span style={{ color: 'red', fontSize: '15px' }}>*</span>
                                    : null
                            }
                        </InputGroupText>
                    {/*</InputGroupAddon>*/}
              
                    <Input
                        fieldname='label'
                        value=''
                        readOnly={true}></Input>
                    <Dropdown
                        addonType="append"
                        isOpen={this.state.dropdownOpen}
                        toggle={this.toggleDropDown.bind(this)}>

                        <DropdownToggle
                            caret color="secondary"
                            onClick={this.selectClicked.bind(this)}>
                            Select
                        </DropdownToggle>

                        {this.state.popupVisible
                            ? <PetMultiSelect2
                                selectedPets={this.state.pets}
                                onCancel={this.onPetSelectCancel.bind(this)}
                                onConfirm={this.onPetSelectConfirm.bind(this)}
                                maxNumberToSelect={this.props.regularExpression}
                            />
                            : null}
                    </Dropdown>
                </InputGroup>

                {this.state.pets?.map(pet =>
                    <InputGroup key={pet.Id}>
                        <FaArrowRight
                            style={{ color: 'darkgrey' }}
                            size='28' />
                        <Input
                            fieldname='label'
                            value={pet.FullName + ' - ' + pet.OwnerName}
                            readOnly={true}
                            style={{ background: 'lightgrey' }}>
                        </Input>
                    </InputGroup>
                )}
            </Fragment>
        );
    }

    onPetSelectCancel() {
        this.setState({ popupVisible: false })
    }

    onPetSelectConfirm(selectedPets) {
        this.props.onUpdate(selectedPets,
            true,
            this.props.fieldname);
        this.setState({
            popupVisible: false,
            pets: selectedPets
        })
    }

    selectClicked() {
        this.setState({ popupVisible: !this.state.popupVisible })
    }

    toggleDropDown() {
        this.setState({ dropdownOpen: !this.state.dropdownOpen });
    }
}